<template>
    <ul class="offcanvas_list">
        <li>
            <a href="#" @click="toggleModal(), openProfile()">
                <fa :icon="['fal', 'user-pen']" />
                <span>{{ t('frontend.edit-my-profile-text') }}</span>
            </a>
        </li>
        <li @click="toggleModal">
            <router-link to="/setting/general">
                <fa :icon="['fal', 'gear']" />
                <span>{{ t('frontend.settings-text') }}</span>
            </router-link>
        </li>
        <li>
            <a @click.prevent="logoutUser">
                <fa :icon="['fal', 'arrow-right-from-bracket']" />
                <span>{{ t('frontend.logout-text') }}</span>
            </a>
        </li>
    </ul>
</template>

<script setup>
// Vue router import
import { useRouter } from "vue-router";

// Modal import
import useToggleModal from "@/composables/useToggleModal";

// API services imports
import { logout } from "@/api/AuthServices";

// Pinia import
import { useAuthStore } from "@/stores/auth";

// I18n imports
import { useI18n } from 'vue-i18n';

// use global scope
const { t, locale } = useI18n();

const authStore = useAuthStore();
const router = useRouter();
const emit = defineEmits(['openProfile']);
const openProfile = () => {
    emit('openProfile');
}
const { toggleModal } = useToggleModal();

const logoutUser = async () => {
    const response = await logout();

    if (response.code === 200) {
        toggleModal();
        localStorage.clear();
        // authStore.setAuthUser({});
        window.location = `${import.meta.env.VITE_APP_DOMAIN}/login`;
    }
};

</script>
<style scoped>
.offcanvas_list {
    @apply p-6;
}

.offcanvas_list li a {
    @apply flex py-6 border-b border-gray-200 dark:border-black-900 cursor-pointer;
}

.offcanvas_list li a svg {
    @apply text-xl text-green-500 ltr:mr-2 rtl:ml-2;
}

.offcanvas_list li a span {
    @apply text-sm font-light text-dark-200 dark:text-white;
}

.offcanvas_list li:last-of-type a {
    @apply border-b-0;
}
</style>
